(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitava-product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.querySelectorAll('details').forEach((details) => {
            const summary = details.querySelector('summary');
            const content = details.querySelector('.vitava-product-faq__answer-wrap');

            if (!summary || !content) return;

            summary.addEventListener('click', (event) => {
              if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

              event.preventDefault();
              this.toggle(details, content);
            });
          });
        }

        toggle(details, content) {
          if (details._faqAnimation) {
            details._faqAnimation.finish();
          }

          if (details.open) {
            details._faqAnimation = content.animate(
              [
                { blockSize: `${content.offsetHeight}px`, opacity: 1 },
                { blockSize: '0px', opacity: 0 }
              ],
              { duration: 220, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
            );

            details._faqAnimation.onfinish = () => {
              details.open = false;
              details._faqAnimation = null;
            };
          } else {
            details.open = true;
            const targetHeight = content.scrollHeight;

            details._faqAnimation = content.animate(
              [
                { blockSize: '0px', opacity: 0 },
                { blockSize: `${targetHeight}px`, opacity: 1 }
              ],
              { duration: 480, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
            );

            details._faqAnimation.onfinish = () => {
              details._faqAnimation = null;
            };
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
